import { render, staticRenderFns } from "./cardArea.vue?vue&type=template&id=6007d06c&scoped=true&"
import script from "./cardArea.vue?vue&type=script&lang=js&"
export * from "./cardArea.vue?vue&type=script&lang=js&"
import style0 from "./cardArea.vue?vue&type=style&index=0&id=6007d06c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6007d06c",
  null
  
)

export default component.exports